import type { FC } from "react";
import React, { useCallback } from "react";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

import { useLocalStorage } from "../../../hooks/local_storage";

import "./styles.scss";

export const BoardToggle: FC = () => {
    const [mode, setMode] = useLocalStorage<"default" | "board">("mode", "default");
    const handleChange = useCallback((_, value) => setMode(value), []);

    return (
        <div className="board-toggle">
            <ToggleButtonGroup exclusive onChange={handleChange} size="small" value={mode}>
                <ToggleButton value="default">Обычно</ToggleButton>
                <ToggleButton value="board">На доске</ToggleButton>
            </ToggleButtonGroup>
        </div>
    );
};
